export default __webpack_public_path__ + "static/media/arrowLeft.be2637f3.svg";